<template>
  <section>
    <div class="relative pb-7">
      <h1
        class="absolute top-7 left-0 right-0 bottom-0 text-orange-600 text-lg font-semibold text-center"
      >
        {{ translations.header }}
      </h1>
    </div>

    <div
      class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
    >
      <BackSvg @click="$router.go(-1)" />
    </div>

    <div class="my-8 flex items-center justify-center">
      <form
        @submit.prevent="GenerateLOAHandler()"
        class="w-full max-w-md space-y-6"
      >
        <div
          class="flex gap-3 p-4 mt-4 border border-amber-200 bg-amber-50 rounded-xl"
        >
          <div class="flex-shrink-0">
            <svg
              class="w-5 h-5 text-amber-500 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
              />
            </svg>
          </div>

          <div>
            <h3 class="text-sm font-semibold text-amber-800">
              {{ translations.title }}:
            </h3>

            <p class="mt-1 text-sm text-amber-700 leading-relaxed">
              {{ translations.details }}
            </p>
          </div>
        </div>
        <div class="flex flex-col space-y-3">
          <span class="text-orange-400 text-sm">{{
            translations.selectionOne
          }}</span>
          <input
            required
            class="px-2 py-3 text-base rounded-lg bg-white backdrop-blur-md border border-zinc-400 text-black placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#E87055]/50 focus:border-transparent transition"
            v-model="providername"
            @input="filterSuggestions"
            type="text"
            :placeholder="translations.selectionOne"
          />
          <div class="relative">
            <ul
              v-if="showSuggestions && itemProviders.length"
              class="absolute top-full mt-2 w-full bg-white border border-zinc-200 rounded-2xl shadow-xl z-50 max-h-60 overflow-y-auto divide-y divide-zinc-100"
            >
              <li
                v-for="(provider, index) in itemProviders"
                :key="index"
                @click="selectProvider(provider, provider.provider_pfs)"
                class="px-4 py-3 cursor-pointer hover:bg-orange-50 active:bg-orange-100 transition duration-150"
              >
                <div class="flex items-start gap-3">
                  <!-- Icon Container -->
                  <div
                    class="w-9 h-9 flex items-center justify-center rounded-full bg-orange-50 text-orange-500 shrink-0"
                  >
                    <HospitalSvg class="w-4 h-4" />
                  </div>

                  <!-- Text Content -->
                  <div class="flex flex-col">
                    <span class="text-sm font-semibold text-zinc-800">
                      {{ provider.ProviderAmap }}
                    </span>
                    <span class="text-xs text-zinc-500 mt-0.5">
                      {{ provider.Branch }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <span class="text-orange-400 text-sm">{{
            translations.selectionTwo
          }}</span>

          <select
            v-model="selectedPFee"
            @change="selectedPFDetails"
            required
            class="px-2 py-3 text-base rounded-lg bg-white backdrop-blur-md border border-zinc-400 text-black placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-[#E87055]/50 focus:border-transparent transition"
          >
            <option value="" disabled>{{ translations.selectionTwo }}</option>
            <option
              v-for="(item, index) in itemPFees"
              :key="index"
              :value="item"
            >
              {{ item.Category }}
            </option>
          </select>
        </div>
        <div class="flex gap-4 items-start">
          <input type="checkbox" class="scale-125 mt-3" required />
          <div class="text-sm text-zinc-600 leading-6">
            {{ translations.dataPrivacy }}
            <a @click="modalConsent()" class="text-blue-600 underline">{{
              translations.detailExpand
            }}</a>
          </div>
        </div>
        <button
          type="submit"
          class="mt-2 w-full py-5 rounded-xl bg-[#E87055] text-white font-semibold hover:scale-105 active:scale-95 transition duration-200 flex items-center justify-center"
        >
          <template v-if="!loading">Generate LOA</template>
          <template v-else>
            <svg
              class="animate-spin h-7 w-7 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          </template>
        </button>
      </form>
    </div>
  </section>
</template>
<script>
import reusableSwal from "@/utils/composables/swalAlert";
import pdfGenerateHandler from "@/utils/reusables/pdfLetter";
import { inject, reactive, ref, toRefs, computed } from "vue";
import { useRouter } from "vue-router";
import BackSvg from "@/components/svgs/BackSvg.vue";

import { useLanguage } from "@/utils/composables/useLanguage";
import HospitalSvg from "@/components/svgs/HospitalSvg.vue";
export default {
  components: {
    BackSvg,
    HospitalSvg,
  },
  setup() {
    const { selectedLanguage } = useLanguage();
    const router = useRouter();
    const { exportPDF } = pdfGenerateHandler();
    const { alertMessageLapsed, alertMessageInsufficientBalance } =
      reusableSwal();
    const Swal = inject("$swal");
    const axios = inject("$axios");
    const modalConsent = () => {
      const modal = loaConsentModal.value;

      Swal.fire({
        icon: "info",
        title: modal.title,
        html: `
      <div style="max-height: 400px; overflow-y: auto; text-align: justify; padding-right: 10px; font-size: 14px; line-height: 1.6;">

        <ul style="list-style-type: disc; margin-left: 20px;">
          <li>${modal.item1}</li>
        </ul>

        <br/>

        <ul style="list-style-type: disc; margin-left: 20px;">
          <li>${modal.item2}</li>
        </ul>

        <br/>

        <ul style="list-style-type: disc; margin-left: 20px;">
          <li>${modal.item3}</li>
        </ul>

        <br/>

        <p>${modal.footer}</p>

      </div>
    `,
        confirmButtonText: modal.button,
        confirmButtonColor: "#f59e0b",
        width: 600,
        scrollbarPadding: false,
      });
    };
    const providername = ref();
    const itemProviders = ref([]);
    const itemPFees = ref([]);
    const showSuggestions = ref(false);
    const selectedPFee = ref("");
    const loading = ref(false);
    const formData = reactive({
      provider_name: null,
      provider_code: null,
      provider_id: null,
      provider_pf_category: "",
      provider_pf_rate: 0.0,
    });

    const filterSuggestions = async () => {
      const search = providername.value.trim();

      try {
        const { data } = await axios.get("/meta/api/amap/resources/provider", {
          params: { search },
        });
        itemProviders.value = data;
        showSuggestions.value = true;
      } catch (error) {
        itemProviders.value = [];
      }
    };
    const selectProvider = (provider, pfs) => {
      providername.value = `${provider.ProviderAmap} - ${provider.Branch}`;
      formData.provider_name = `${provider.ProviderAmap} - ${provider.Branch}`;
      formData.provider_code = provider.ProviderCode;
      selectedPFee.value = "";

      if (Array.isArray(pfs) && pfs.length > 0) {
        const grouped = Object.values(
          pfs.reduce((acc, item) => {
            const category = item.Category.trim().toLowerCase(); // normalize category
            if (!acc[category] || item.Amount > acc[category].amount) {
              acc[category] = item;
            }
            return acc;
          }, {})
        );

        itemPFees.value = grouped;
      } else {
        itemPFees.value = [];
      }

      showSuggestions.value = false;
    };
    const GenerateLOAHandler = async () => {
      try {
        loading.value = true;

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const { data } = await axios.get(
          "/meta/api/amap/resources/validate/status"
        );
        await delay(2000);
        loading.value = false;
        if (data.status) {
          checkIfEligibleBalance();
        } else {
          alertMessageLapsed();
        }
      } catch (error) {
        console.error("Error fetching providers:", error);
      }
    };
    const checkIfEligibleBalance = async () => {
      try {
        const { data } = await axios.get(
          `/meta/api/amap/resources/validate/balance/${formData.provider_pf_rate}`
        );
        if (data.status) {
          modalConfirmation();
        } else {
          alertMessageInsufficientBalance();
        }
        loading.value = false;
      } catch (error) {
        console.error("Error fetching providers:", error);
      }
    };
    const selectedPFDetails = () => {
      formData.provider_pf_category = selectedPFee.value.Category;
      formData.provider_pf_rate = selectedPFee.value.Amount;
      formData.provider_id = selectedPFee.value.ProviderID;
      console.log(formData.provider_pf_rate);
    };

    const modalConfirmation = () => {
      Swal.fire({
        title: "Confirm LOA Request",
        html: `
    <div style="text-align: left; font-size: 14px; line-height: 1.6;">
      <p><strong>Provider Name:</strong></p>
      <p>${formData.provider_name}</p>
      <p><strong>Category:</strong> ${formData.provider_pf_category}</p>
      <hr style="margin:10px 0;" />
      <p>Are you sure you want to proceed with this request?</p>
    </div>
  `,
        showCancelButton: true,
        confirmButtonColor: "#E87055",
        cancelButtonColor: "#6B7280",
        confirmButtonText: "Yes, Proceed",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          generateLOA();
        }
      });
    };

    const generateLOA = async () => {
      try {
        const result = await axios.post(
          `/meta/api/amap/resources/generate/loa`,
          formData
        );

        if (result.data) {
          const modal = loaSuccessModal.value;

          Swal.fire({
            icon: "success",
            title: modal.title,
            html: `
          <div style="font-size:14px; line-height:1.6; text-align:left;">
            <p>${modal.message}</p>

            <div style="
              background:#FFF3CD;
              border-left:4px solid #FFC107;
              padding:10px;
              margin:10px 0;
              border-radius:4px;
            ">
              <strong>${modal.noticeTitle}</strong><br>
              ${modal.notice}
            </div>

            <p>${modal.footer}</p>
          </div>
        `,
            confirmButtonText: modal.button,
            confirmButtonColor: "#E87055",
          }).then((resultSwal) => {
            if (resultSwal.isConfirmed) {
              exportPDF(result.data);
              router.push(`/auth/home`);
            }
          });
        }
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    };

    const translations = computed(
      () =>
        ({
          en: {
            header: "Request of Letter of Authorization",
            title: "Takeaway Notes",
            details:
              "Online LOA generation is currently available only for selected accredited providers. Additional providers will be added progressively as system integration continues.",
            dataPrivacy:
              "I understand and consent that my personal and health information will be used to generate my LOA in compliance with Philippine laws, including the Data Privacy Act of 2012.",
            detailExpand: "Learn more",
            selectionOne: "Select Provider",
            selectionTwo: "Select Specialization",
          },
          ph: {
            header: "Pagproseso ng Serbisyong Medikal",
            title: "Mahalagang Paalala",
            details:
              "Ang online na pagkuha ng LOA ay kasalukuyang available lamang para sa mga piling accredited provider. Unti-unti pang idaragdag ang iba pang provider habang nagpapatuloy ang integrasyon ng sistema",
            dataPrivacy:
              "Nauunawaan ko at sumasang-ayon ako na ang aking personal at impormasyong pangkalusugan ay gagamitin upang mabuo ang aking LOA, alinsunod sa mga batas ng Pilipinas, kabilang ang Data Privacy Act of 2012.",
            detailExpand: "Alamin pa.",
            selectionOne: "Pumili ng Serbisyong Provider",
            selectionTwo: "Piliin ang Uri ng Espesyalista",
          },
        }[selectedLanguage.value])
    );
    const loaConsentModal = computed(() =>
      selectedLanguage.value === "ph"
        ? {
            title: "Pahintulot para sa Letter of Authorization (LOA)",
            item1:
              "Ang Letter of Authorization (LOA) na ito ay may bisa lamang sa loob ng tatlong (3) araw mula sa petsa ng pagkakabigay. Kung hindi ito magagamit sa loob ng nasabing panahon, awtomatiko itong mawawalan ng bisa.",
            item2:
              "Maaaring kanselahin ang LOA bago ito ma-verify ng HMO Department ng provider. Kapag na-verify na, hindi na ito maaaring kanselahin o baguhin.",
            item3:
              "Ang anumang halagang lalampas sa aprubadong saklaw ng benepisyo ay sasagutin ng miyembro o pasyente.",
            footer:
              "Mangyaring basahing mabuti bago magpatuloy. Sa pag-click ng “Nauunawaan Ko”, kinukumpirma mong nabasa, naunawaan, at tinatanggap mo ang mga tuntunin ng LOA na ito.",
            button: "Nauunawaan Ko",
          }
        : {
            title: "Letter of Authorization (LOA) Consent",
            item1:
              "This Letter of Authorization (LOA) shall be valid for three (3) days from the date of issuance. If not availed within the said period, it shall automatically be considered void.",
            item2:
              "The LOA may only be voided prior to verification by the provider's HMO Department. Once verified, the LOA can no longer be canceled or amended.",
            item3:
              "Any amount exceeding the approved benefit coverage shall be charged to the member/patient.",
            footer:
              'Please read carefully before proceeding. By clicking "I Understand," you confirm that you have read, understood, and accepted the terms of this LOA.',
            button: "I Understand",
          }
    );

    const loaSuccessModal = computed(() =>
      selectedLanguage.value === "ph"
        ? {
            title: "Naiproseso ang Iyong LOA",
            noticeTitle: "Paalala:",
            message: "Naiproseso na ang inyong Letter of Authorization (LOA).",
            notice:
              "Ang LOA na na-generate sa pamamagitan ng AMAP platform ay kinakailangang ipakita sa HMO Department ng ospital o klinika, kasama ang inyong HMO card at isang valid na ID, para sa beripikasyon.",
            footer:
              "Pakiclick ang button sa ibaba upang ma-download ang inyong kopya ng LOA.",
            button: "I-download ang LOA",
          }
        : {
            title: "LOA Successfully Generated",
            noticeTitle: "Important Notice:",
            message:
              "Your Letter of Authorization (LOA) has been successfully generated.",
            notice:
              "The LOA generated through the AMAP platform must be presented to the HMO Department of the hospital or clinic, together with your HMO card and a valid ID, for verification.",
            footer: "Please click the button below to download your copy.",
            button: "Download LOA",
          }
    );
    return {
      modalConsent,
      providername,
      filterSuggestions,
      selectProvider,
      itemProviders,
      showSuggestions,
      itemPFees,
      selectedPFee,
      GenerateLOAHandler,
      checkIfEligibleBalance,
      loading,
      ...toRefs(formData),
      selectedPFDetails,
      modalConfirmation,
      generateLOA,
      exportPDF,
      alertMessageLapsed,
      alertMessageInsufficientBalance,
      selectedLanguage,
      translations,
      loaConsentModal,
      loaSuccessModal,
    };
  },
};
</script>
